import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Forbidden from './pages/Forbidden';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import ClientDetail from './pages/ClientDetail';
import RepSessions from './pages/RepSessions';
import SessionReview from './pages/SessionReview';
import Reps from './pages/Reps';
import Support from './pages/Support';
import Features from './pages/Features';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forbidden" element={<Forbidden />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/clients/:tenantId" element={<ClientDetail />} />
              {/* Session review. Declared before the drill-down would ever be
                  ambiguous with them; both are read-only and range-aware via
                  the query string. */}
              <Route path="/clients/:tenantId/reps/:userId/sessions" element={<RepSessions />} />
              <Route path="/clients/:tenantId/sessions/:sessionId" element={<SessionReview />} />
              <Route path="/reps" element={<Reps />} />
              <Route path="/features" element={<Features />} />
              <Route path="/support" element={<Support />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
